import { z } from 'zod'

import {
  type LoginPortalEmail,
  type LoginPortalPage,
  loginPortalSchema,
} from '@scalar-org/entities/login-portals'

import type { RequestService } from '../request'

export function loginPortalsApiFactory(requestService: RequestService) {
  async function get(slug: string) {
    return await requestService.request({
      url: `core/login-portals/${slug}`,
      method: 'get',
      schema: loginPortalSchema,
    })
  }

  async function create(data: {
    title: string
    slug: string
    email: LoginPortalEmail
    page: LoginPortalPage
  }) {
    return await requestService.request({
      url: 'core/login-portals',
      method: 'post',
      data,
      schema: z.object({ uid: z.string() }),
    })
  }

  async function update(data: { slug: string; title?: string }) {
    return await requestService.request({
      url: 'core/login-portals/update',
      method: 'post',
      data,
      schema: z.null(),
    })
  }

  async function del(slug: string) {
    return await requestService.request({
      url: 'core/login-portals',
      data: { slug },
      method: 'delete',
      schema: z.null(),
    })
  }

  async function getLoginPortals() {
    return await requestService.request({
      url: 'core/login-portals',
      method: 'get',
      schema: loginPortalSchema
        .pick({
          uid: true,
          title: true,
          slug: true,
        })
        .array(),
    })
  }

  return {
    /** Get a login portal by namespace/slug combination */
    get,
    /** Creates a new login portal */
    create,
    /** Update login portal metadata */
    update,
    /** Delete a login portal and remove any associates to projects or docs */
    delete: del,
    /** Get a list of all login portal related to the namespace */
    getLoginPortals,
  }
}
